import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const ConfirmationModal = ({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmButtonColor = '#E74C3C'
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      sx={{
        '& .MuiDialog-paper': {
          backgroundColor: '#F7F7F7',
          borderRadius: '8px',
          width: '90vw',
          maxWidth: '500px',
          boxShadow: '6px 6px 6px #00000040',
          fontFamily: 'Nunito Sans, sans-serif',
          padding: '20px 30px'
        }
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '16px'
        }}
      >
        <DialogTitle
          sx={{
            fontFamily: 'Nunito Sans, sans-serif',
            fontSize: '24px',
            fontWeight: 700,
            color: '#202224',
            padding: 0
          }}
        >
          {title}
        </DialogTitle>
        <FontAwesomeIcon
          icon={faTimes}
          style={{
            height: '17px',
            width: '17px',
            color: '#FF7A00',
            cursor: 'pointer'
          }}
          onClick={onCancel}
        />
      </div>
      <DialogContent sx={{ padding: 0, marginBottom: '24px' }}>
        <DialogContentText
          sx={{
            fontFamily: 'Nunito Sans, sans-serif',
            fontSize: '16px',
            color: '#202224',
            lineHeight: '1.5'
          }}
        >
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          padding: 0,
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '16px'
        }}
      >
        <Button
          onClick={onCancel}
          variant="outlined"
          sx={{
            borderRadius: '5px',
            textTransform: 'none',
            fontSize: '14px',
            padding: '2px 16px',
            color: '#202224',
            borderColor: '#202224',
            fontFamily: 'Nunito Sans, sans-serif',
            '&:hover': {
              borderColor: '#FF7A00',
              backgroundColor: '#FFF3E5'
            }
          }}
        >
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            backgroundColor: confirmButtonColor,
            borderRadius: '5px',
            textTransform: 'none',
            fontSize: '14px',
            padding: '2px 16px',
            fontFamily: 'Nunito Sans, sans-serif',
            color: '#FFFFFF',
            '&:hover': {
              backgroundColor: confirmButtonColor,
              opacity: 0.9
            }
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;